import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomTextField from '../../components/forms/CustomTextField';

import CustomeMultlineForm from '../../components/forms/CustomeMultlineForm';

const createCategoryValidationSchema = Yup.object({
    category_name: Yup.string().required('Category name is required').max(20),
    description: Yup.string(),
});

const CreateCategory = () => {
    return (
        <>
            <Formik
                initialValues={{
                    category_name: '',
                    description: '',
                }}
                validationSchema={createCategoryValidationSchema}
                onSubmit={() => {}}
            >
                {(formik) => (
                    <Form>
                        <Grid container spacing={2} justifyContent={'center'}>
                            <Grid item sm={12}>
                                <CustomTextField
                                    name="category_name"
                                    label={'Category name'}
                                    color="primary"
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <CustomeMultlineForm
                                    name="description"
                                    label={'Category description'}
                                    color="primary"
                                    rows={5}
                                />
                            </Grid>
                            <Grid item sm={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        className="app-btn"
                                        onClick={formik.handleSubmit}
                                    >
                                        Create category
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default CreateCategory;
